let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("7TGYM")]).then(() => parcelRequire('kg3vi'));